// src/screens/admin/notifications/Notifications.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Modal, Form, ListGroup } from 'react-bootstrap';
import AdminLayout from '../../../layouts/admin/adminlayout/AdminLayout';
import '../../../assets/css/admin/adminNotifications/AdminNotifications.css';
import axios from 'axios';
import { useContext } from 'react';
import AppContext from '../../../context/AppContext';

const Notifications = () => {
  const { baseUrl } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [filterType, setFilterType] = useState('all');
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inAppNotifications, setInAppNotifications] = useState(true);
  // Form states for creating a notification
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('info');
  const [sendTo, setSendTo] = useState('all');
  const [sendEmail, setSendEmail] = useState(false);

  const getTypeColor = (type) => {
    switch (type) {
      case 'success': return 'success';
      case 'danger': return 'danger';
      case 'warning': return 'warning';
      case 'info': return 'info';
      default: return 'secondary';
    }
  };


  const filteredNotifications = filterType === 'all'
    ? notifications
    : filterType === 'unread'
      ? notifications.filter(n => !n.read)
      : notifications.filter(n => n.type === filterType);

  const viewAllNotifications = () => {
    axios.post(`${baseUrl}/admin/notification/viewAllNotifications`)
      .then(response => {
        console.log(response.data);
        setNotifications(response.data.notifications);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const markAllAsRead = () => {
    axios.post(`${baseUrl}/admin/notification/markAllAsRead`)
      .then(response => {
        console.log(response.data);
        viewAllNotifications();
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleMarkAsRead = (id) => {
    setNotifications(notifications.map(n =>
      n.id === id ? { ...n, read: true } : n
    ));
  };

  const handleMarkAllAsRead = () => {
    markAllAsRead();
  };

  const handleDeleteNotification = (id) => {
    if (window.confirm('Are you sure you want to delete this notification?')) {
      setNotifications(notifications.filter(n => n.id !== id));
    }
  };
  const handleSendNotification = () => {
    const newNotification = {
      id: Date.now(),
      title,
      message,
      type,
      read: false
    };
    setNotifications([...notifications, newNotification]);
    setShowModal(false);
  };


  useEffect(() => {
    viewAllNotifications();
  }, [])

  return (
    <AdminLayout>
      <div className="notifications-page">
        {/* Page Header */}
        <div className="page-header mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="page-title">
                <span className="page-icon">🔔</span>
                Notifications
                
              </h2>
              <p className="text-muted">Manage system notifications and alerts</p>
            </div>
            <div className="d-flex gap-2">
              <Button variant="primary" className="add-mark-all-read-btn" onClick={handleMarkAllAsRead}>
                Mark All Read
              </Button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-blue">
              <Card.Body>
                <div className="stat-icon">🔔</div>
                <div className="stat-info">
                  <h3>{notifications.length}</h3>
                  <p>Total Notifications</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-orange">
              <Card.Body>
                <div className="stat-icon">📬</div>
                <div className="stat-info">
                  <h3>{notifications.filter(n => !n.read).length}</h3>
                  <p>Unread</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-green">
              <Card.Body>
                <div className="stat-icon">✅</div>
                <div className="stat-info">
                  <h3>{notifications.filter(n => n.read).length}</h3>
                  <p>Read</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-red">
              <Card.Body>
                <div className="stat-icon">⚠️</div>
                <div className="stat-info">
                  <h3>{notifications.filter(n => n.type === 'danger').length}</h3>
                  <p>Alerts</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filters */}
        <Card className="mb-4">
          <Card.Body>
            <div className="notification-filters">
              <Button
                variant={filterType === 'all' ? 'primary' : 'outline-secondary'}
                onClick={() => setFilterType('all')}
              >
                All
              </Button>
              <Button
                variant={filterType === 'unread' ? 'primary' : 'outline-secondary'}
                onClick={() => setFilterType('unread')}
              >
                Unread ({notifications.filter(n => !n.read).length})
              </Button>
            </div>
          </Card.Body>
        </Card>

        {/* Notifications List */}
        <Card>
          <Card.Body className="p-0">
            <ListGroup variant="flush">
              {filteredNotifications.map((notification) => (
                <ListGroup.Item
                  key={notification.id}
                  className={`notification-item ${!notification.read ? 'unread' : ''}`}
                >
                  <div className="d-flex align-items-start gap-3">
                    <div className={`notification-icon notification-${notification.type}`}>
                      {notification.icon}
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h6 className="notification-title mb-1">
                            {notification.title}
                            {!notification.read && <Badge bg="primary" className="ms-2">New</Badge>}
                          </h6>
                          <p className="notification-message mb-2">{notification.message}</p>
                          <small className="text-muted">
                            <i className="bi bi-clock"></i> {new Date( notification.created_at).toLocaleString()}
                          </small>
                        </div>

                      </div>
                    </div>
                    <div className="notification-actions">
                      {!notification.read && (
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => handleMarkAsRead(notification.id)}
                        >
                          <i className="bi bi-check"></i>
                        </Button>
                      )}
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDeleteNotification(notification.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
        </Card>

        {/* Send Notification Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Send New Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Notification Title</Form.Label>
                <Form.Control type="text" placeholder="Enter notification title" />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control as="textarea" rows={4} placeholder="Enter notification message" />
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type</Form.Label>
                    <Form.Select>
                      <option value="info">Info</option>
                      <option value="success">Success</option>
                      <option value="warning">Warning</option>
                      <option value="danger">Danger</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Send To</Form.Label>
                    <Form.Select>
                      <option>All Users</option>
                      <option>All Students</option>
                      <option>All Mentors</option>
                      <option>Specific User</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Check type="checkbox" label="Send email notification as well" />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
            <Button variant="primary">Send Notification</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default Notifications;